export const mutations = {
  SET_AUTH_USER_ENTITY_ACTIVITIES (state, { records }) {
    state.authUserEntityActivities = records
    state.hasLoadedAuthUserEntityActivities = true
  },

  RESET_AUTH_USER_ENTITY_ACTIVITIES (state) {
    state.authUserEntityActivities = []
    state.hasLoadedAuthUserEntityActivities = false
  }
}
